import { useRef } from 'react';
import { DragNumberProps, PresetOption } from './types';
import { PresetDropdown } from './preset-dropdown';
import { DragHandle } from './drag-handle';
import { CustomInput } from './custom-input';
import { DEFAULT_PRESETS } from './constants';
import { cn } from '@gettactic/helpers';
import { Label } from '../../../../ui/label';
import { useDragNumber } from './hooks/useDragNumber';

export function DragNumberInput({
  label,
  value,
  onChange,
  min = Number.NEGATIVE_INFINITY,
  max = Number.POSITIVE_INFINITY,
  step = 1,
  className,
  presets = DEFAULT_PRESETS as unknown as PresetOption[],
  placeholder,
  size = 'default'
}: DragNumberProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const { isDragging, handleMouseDown } = useDragNumber({
    value,
    onChange,
    min,
    max,
    step
  });

  return (
    <div className={cn('relative flex flex-col gap-2', className)}>
      {label && <Label>{label}</Label>}
      <div className="group relative">
        <DragHandle
          isDragging={isDragging}
          onMouseDown={handleMouseDown}
          size={size}
        />
        <CustomInput
          ref={inputRef}
          value={value}
          onChange={(e) => onChange(Number(e.target.value))}
          min={min}
          max={max}
          step={step}
          placeholder={placeholder}
          size={size}
          isDragging={isDragging}
        />
        <div className="absolute right-0 top-0 h-full opacity-0 group-hover:opacity-100 transition-opacity">
          <PresetDropdown presets={presets} onSelect={onChange} size={size} />
        </div>
      </div>
    </div>
  );
}
